import e from"./Highlighter.vue_vue&type=script&lang.js";import{render as t}from"./Highlighter.vue_vue&type=template&id=11ec06d9&lang.js";e.render=t;export default e;
//# sourceMappingURL=Highlighter.vue.js.map
